import React, { useEffect, useMemo, useState } from 'react';
import styles from '../../styles/Sidebar.module.scss';
import { useSelector } from 'react-redux';
import ContactsBlock from './ContactsBlock';
import NewProductsCarousel from './NewProductsCarousel';
import SidebarCategoryMenu from './SidebarCategoryMenu';
import { getCategoryTreeWithProducts } from '../../utils/categoryTree';

const Sidebar = ({ layout = 'default', catalogMaxHeight = null, onCallbackRequest }) => {
  const { list } = useSelector(({ categories }) => categories);
  const { list: products } = useSelector(({ products }) => products);
  const { data: contacts } = useSelector((state) => state.contacts);
  const [isCompact, setIsCompact] = useState(false);
  const [catalogOpen, setCatalogOpen] = useState(true);
  const [contactsOpen, setContactsOpen] = useState(false);

  const catalogTree = useMemo(
    () => getCategoryTreeWithProducts(list, products, { onlyPublished: true }),
    [list, products]
  );

  useEffect(() => {
    const media = window.matchMedia('(max-width: 768px)');

    const updateMode = () => {
      const compact = media.matches;
      setIsCompact(compact);
      setCatalogOpen(!compact);
      setContactsOpen(false);
    };

    updateMode();
    media.addEventListener('change', updateMode);
    return () => media.removeEventListener('change', updateMode);
  }, []);

  return (
    <section
      className={`${styles.sidebar}${isCompact ? ` ${styles.sidebarCompact}` : ''}${
        layout === 'product' ? ` ${styles.sidebarProduct}` : ''
      }${layout === 'hero' ? ` ${styles.sidebarHero}` : ''}`}
    >
      <div className={`${styles.sidebarPanel} ${styles.catalogPanel}`}>
        {isCompact ? (
          <button
            type="button"
            className={`${styles.sectionToggle}${catalogOpen ? ` ${styles.sectionToggleOpen}` : ''}`}
            onClick={() => setCatalogOpen((prev) => !prev)}
            aria-expanded={catalogOpen}
          >
            <span className={styles.title}>КАТАЛОГ</span>
            <span className={styles.sectionChevron} aria-hidden="true" />
          </button>
        ) : (
          <div className={styles.title}>КАТАЛОГ</div>
        )}
        <div className={`${styles.sectionBody}${!isCompact || catalogOpen ? ` ${styles.sectionBodyOpen}` : ''}`}>
          <SidebarCategoryMenu
            tree={catalogTree}
            categories={list}
            catalogMaxHeight={layout === 'hero' ? catalogMaxHeight : null}
          />
        </div>
      </div>

      <div className={`${styles.sidebarPanel} ${styles.novinkiPanel}`} data-sidebar-part="novinki">
        <NewProductsCarousel />
      </div>

      {isCompact ? (
        <div className={`${styles.sidebarPanel} ${styles.contactsPanel}`} data-sidebar-part="contacts">
          <button
            type="button"
            className={`${styles.sectionToggle}${contactsOpen ? ` ${styles.sectionToggleOpen}` : ''}`}
            onClick={() => setContactsOpen((prev) => !prev)}
            aria-expanded={contactsOpen}
          >
            <span className={styles.contactsTitle}>КОНТАКТИ</span>
            <span className={styles.sectionChevron} aria-hidden="true" />
          </button>
          <div className={`${styles.sectionBody}${contactsOpen ? ` ${styles.sectionBodyOpen}` : ''}`}>
            <ContactsBlock contacts={contacts} hideHeader onCallbackRequest={onCallbackRequest} />
          </div>
        </div>
      ) : (
        <div data-sidebar-part="contacts">
          <ContactsBlock contacts={contacts} onCallbackRequest={onCallbackRequest} />
        </div>
      )}
    </section>
  );
};

export default Sidebar;
